import SpecialShopPage from './special-shop.component';

export default SpecialShopPage;
